import * as React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";

interface Props {
  min: number;
  max: number;
  fromValue: number;
  toValue: number;
  onChangeFromValue: (value: number) => void;
  onChangeToValue: (value: number) => void;
}

const RangeSlider: React.FC<Props> = ({
  min,
  max,
  fromValue,
  toValue,
  onChangeFromValue,
  onChangeToValue,
}) => {
  return (
    <SliderContainer>
      <Input
        type="range"
        min={min}
        max={max}
        value={fromValue}
        onChange={(e) => onChangeFromValue(Number(e.target.value))}
        className="thumb thumb--left"
        style={{ zIndex: fromValue > max - 100 ? "5" : "3" }}
      />
      <Input
        type="range"
        min={min}
        max={max}
        value={toValue}
        onChange={(e) => onChangeToValue(Number(e.target.value))}
        className="thumb thumb--right"
      />
      <Slider>
        <Track />
        <Range
          style={{
            left: `${((fromValue - min) / (max - min)) * 100}%`,
            right: `${100 - ((toValue - min) / (max - min)) * 100}%`,
          }}
        />
      </Slider>
    </SliderContainer>
  );
};

export default RangeSlider;

const SliderContainer = styled.div`
  position: relative;
  width: 100%;
`;

const Input = styled.input`
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  background: transparent;
  position: absolute;
  pointer-events: none;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    background: white;
    border: 2px solid ${theme.colors.primary};
    cursor: pointer;
    pointer-events: all;
    position: relative;
    margin-top: -11px;
    z-index: 5;
  }

  &::-moz-range-thumb {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    background: white;
    border: 2px solid green;
    cursor: pointer;
    pointer-events: all;
    position: relative;
  }
`;

const Slider = styled.div`
  position: relative;
  height: 10px;
  margin: 0 15px;
  background: linear-gradient(262.62deg, #4d4d4d 0%, #3d7276 100%);
  border-radius: 5px;
`;

const Track = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: #ddd;
  border-radius: 5px;
`;

const Range = styled.div`
  position: absolute;
  height: 100%;
  background: ${theme.colors.primaryDark};
  border-radius: 5px;
`;
